import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { HeroImageComponentType } from "@swo/storefront";

import { css } from "@emotion/react";

import { HeroImageHeadline } from "./HeroImageHeadline";
import { HeroImageCallToAction } from "./HeroImageCallToAction";
import React from "react";
import cn from "classnames";
import { CSS_MQ } from "../../../styles/breakpoints";
import { FONTS } from "../../../styles/fonts";
import { DownArrowSvg } from "../../../assets";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const HeroImageHeadlines: ReactTFC<{
  seoHeadline: HeroImageComponentType["seoHeadline"];
  emoHeadline: HeroImageComponentType["emoHeadline"];
  description: string | undefined;
  callToAction: HeroImageComponentType["callToAction"];
  headlineStyle: "normal" | "bold";
  disableChevron?: boolean;
  seoHeadlineStyle: "light" | "normal";
  isFirstHeroComponentOnPage: boolean;
}> = props => {
  return (
    <div
      className={cn(props.headlineStyle, { "no-chevron-nor-cta": !!props.disableChevron && !props.callToAction })}
      css={css`
        &.bold {
          @font-face {
            font-family: SwarovskiFutura;
            src: url("/assets/fonts/SwarovskiFutura-Bold.woff2") format("woff2");
            font-weight: 700;
            font-style: normal;
            font-display: swap;
          }
        }

        .variant-switcher-on-hero-image & {
          grid-area: 3/1 / span 1/2;
        }

        .variant-switcher-as-tabs & {
          grid-area: 4/1 / span 1/2;
        }

        &.no-chevron-nor-cta {
          margin-bottom: 20px;

          ${CSS_MQ.atLeastMd} {
            margin-bottom: 70px;
          }
        }

        align-self: flex-start;
        justify-self: center;
        text-align: center;

        z-index: 3;

        --x: 12px;

        margin-left: var(--x);
        margin-right: var(--x);

        display: flex;
        flex-direction: column;
        width: calc(100% - 2 * var(--x));
      `}
    >
      <HeroImageHeadline
        seoHeadline={props.seoHeadline || undefined}
        emoHeadline={props.emoHeadline || undefined}
        headlineStyle={props.headlineStyle}
        seoHeadlineStyle={props.seoHeadlineStyle}
        isFirstHeroComponentOnPage={props.isFirstHeroComponentOnPage}
      />

      {props.description && (
        <p
          className="text-aa"
          css={css`
            max-width: 90%;
            text-align: center;
            font-size: 20px;
            margin: 0px auto 20px auto;
            ${FONTS.SwarovskiFutura300};
            letter-spacing: 1.05px;

            ${CSS_MQ.atLeastMd} {
              font-size: 22px;
              max-width: 75%;
            }

            ${CSS_MQ.atLeastLg} {
              font-size: 25px;
              max-width: 900px;
            }
          `}
        >
          {props.description}
        </p>
      )}

      {props.callToAction && <HeroImageCallToAction {...props.callToAction} />}
      {!props.disableChevron && <DownArrowSvg css={chevronStyles} />}
    </div>
  );
};

const chevronStyles = css`
  display: block;

  color: ${CSS_COLORS.White};

  margin-bottom: 24px;
  margin-left: auto;
  margin-right: auto;

  width: 30px;
  height: 30px;
`;
